import { formatMoneyWhole } from '@/lib/formatMoney';
import { useCoverAsset } from '@/hooks/useCoverAsset';
import type { OrderItem } from '@/hooks/useOrderDetails';

interface OrderItemRowProps {
  item: OrderItem;
  currency: string;
}

function ItemThumb({ productId, title }: { productId: string | null; title: string }) {
  const { url320 } = useCoverAsset('product', productId);
  const letter = (title?.[0] ?? '?').toUpperCase();

  if (url320) {
    return (
      <img
        src={url320}
        alt={title}
        className="h-14 w-14 rounded-2xl object-cover"
        loading="lazy"
      />
    );
  }

  return (
    <div className="h-14 w-14 rounded-2xl bg-muted flex items-center justify-center">
      <span className="text-base font-medium text-muted-foreground">{letter}</span>
    </div>
  );
}

export function OrderItemRow({ item, currency }: OrderItemRowProps) {

  return (
    <div className="flex items-start gap-4 py-3">
      {/* Thumbnail */}
      <div className="shrink-0">
        <ItemThumb productId={item.product_id ?? null} title={item.title} />
      </div>

      {/* Details */}
      <div className="flex-1 min-w-0">
        <p className="font-medium text-sm sm:text-base truncate">{item.title}</p>
        <p className="text-sm text-muted-foreground mt-0.5">
          {item.quantity} × {formatMoneyWhole(item.unit_amount, currency)}
        </p>
      </div>

      {/* Total */}
      <div className="text-right shrink-0">
        <p className="font-medium text-sm sm:text-base">
          {formatMoneyWhole(item.total_amount, currency)}
        </p>
      </div>
    </div>
  );
}
